module.exports = __webpack_public_path__ + "static/media/clara.555173c0.jpg";